import {
  ArrowLeftOutlined,
  CaretDownOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Row, Select } from "antd";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MultiSelect from "../../../../components/common/MultiSelect";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import { Propertiesunitscampaigns } from "../../../../data/renewals";

import "./ScheduledReportDetails.css";

const { TextArea } = Input;

const ScheduledReportsDetails = () => {
  const location = useLocation();
  const rowData = location.state.rowData;

  const [scheduleReports, setScheduleReports] = useState(rowData);
  const [isEditing, setIsEditing] = useState(false);
  const [editShown, setEditShown] = useState(true);

  const ScheduledReportsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        "New Scheduled Report",
        "1",
        "",
        "",
        "/reporting/scheduled-reports/new"
      ),
      RightBarMethod("Delete Scheduled Report", "2", "", "", ""),
    ]),
  ];
  const emailList =
    '"Aamir Khan" <aamir@chkar.com>, "Aamir Khan" <aamiralikhan.ali@gmail.com>, "aamir ali" <this.getinstance@gmail.com>, "seerat ali" <seerat@gmail.com>, "Tenant tenant" <seeratayshah@gmail.com>';

  const handleEditClick = () => {
    setIsEditing(true);
    setEditShown(false);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    setEditShown(true);
  };
  const cancelReport = () => {
    setIsEditing(false);
    setEditShown(true);
  };
  const savedReports = [
    {
      value: "Copy of Unit Vacancy Detail- SS",
      label: "Copy of Unit Vacancy Detail- SS",
    },
    {
      value: "Lead Source",
      label: "Lead Source",
    },
    {
      value: "Lead For 9304",
      label: "Lead For 9304",
    },
    {
      value: "1010 Farra",
      label: "1010 Farra",
    },
    {
      value: "Drapper drive listing",
      label: "Drapper drive listing",
    },
    {
      value: "End of year cash flow report",
      label: "End of year cash flow report",
    },
    {
      value: "Copy of unit Vacancy",
      label: "Copy of unit Vacancy",
    },
  ];

  const format = [
    {
      value: "PDF",
      label: "PDF",
    },
    {
      value: "CSV",
      label: "CSV",
    },
    {
      value: "XLSX",
      label: "XLSX",
    },
  ];

  const frequencyOptions = [
    {
      value: "Daily",
      label: "Daily",
    },
    {
      value: "Weekly",
      label: "Weekly",
    },
    {
      value: "Monthly",
      label: "Monthly",
    },
  ];
  return (
    <>
      <div className="ScheduleReportDetails">
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="arrow-styling">
              <ArrowLeftOutlined style={{}} />
            </div>
          </Col>
          <Col>
            <Link to="/reporting/scheduled-reports">
              Back to scheduled reports
            </Link>
          </Col>
        </Row>
        <PageHeading heading="Scheduled Reports" />
        <Row>
          <Card
            title={
              !isEditing
                ? scheduleReports.name.replace(/\b\w/g, (c) => c.toUpperCase())
                : "Schedule Details"
            }
            extra={<a onClick={handleEditClick}>{editShown && "Edit"}</a>}
            style={{
              width: "100%",
            }}
          >
            <Form
              layout="vertical"
              name="basic"
              labelCol={{ span: 7 }}
              autoComplete="off"
              className="form-container"
              colon={false}
            >
              <Row gutter={[12, 12]}>
                {isEditing && (
                  <Col span={24}>
                    <Col style={{ display: "flex", margin: "10px" }}>
                      <Col
                        span={6}
                        className="label-style"
                        style={{
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        {isEditing && (
                          <span style={{ color: "red", marginRight: "3px" }}>
                            *
                          </span>
                        )}
                        Schedule Name
                      </Col>

                      <Col span={16}>
                        <Form.Item name="Receipts">
                          <Input
                            defaultValue={scheduleReports.name}
                            width="100%"
                          />
                        </Form.Item>
                      </Col>
                    </Col>
                  </Col>
                )}

                <h1 className="title-style">Select Report</h1>
                <Col
                  span={24}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Col span={12} style={{ marginLeft: "-50px" }}>
                    {isEditing ? (
                      <Form.Item
                        label="Saved Reports"
                        name="savedReports"
                        required
                      >
                        {/* <Input defaultValue={scheduleReports.reports} width='100%' /> */}
                        <Select
                          options={savedReports}
                          defaultValue={scheduleReports.reports}
                          suffixIcon={<CaretDownOutlined />}
                        />
                      </Form.Item>
                    ) : (
                      <Col>
                        <Col
                          span={6}
                          className="label-sstyle"
                          style={{ display: "flex", justifyContent: "start" }}
                        >
                          Saved Reports
                        </Col>
                        <Col style={{ marginTop: "4px", fontSize: 13 }}>
                          {scheduleReports.reports}
                        </Col>
                      </Col>
                    )}
                  </Col>
                  <Col span={6}>
                    {isEditing ? (
                      <Form.Item label="Format" required>
                        <Select
                          options={format}
                          defaultValue="PDF"
                          width="50%"
                          suffixIcon={<DownOutlined />}
                        />
                      </Form.Item>
                    ) : (
                      <Col>
                        <Col
                          span={6}
                          className="label-style"
                          style={{ display: "flex", justifyContent: "start" }}
                        >
                          Format
                        </Col>
                        <Col style={{ marginTop: "4px", fontSize: 13 }}>
                          PDF
                        </Col>
                      </Col>
                    )}
                  </Col>
                </Col>

                <h1 className="title-style">Email Options</h1>

                <Col
                  span={24}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Col style={{ display: "flex", margin: "10px" }}>
                    <Col
                      span={6}
                      className="label-style"
                      style={{ display: "flex", justifyContent: "end" }}
                    >
                      {isEditing && (
                        <span style={{ color: "red", marginRight: "3px" }}>
                          *
                        </span>
                      )}
                      Recipients
                    </Col>

                    {isEditing ? (
                      <Col span={16}>
                        <Form.Item name="Receipts">
                          <MultiSelect
                            defaultValue="Receipts"
                            width="100%"
                            suffix={<CaretDownOutlined />}
                            options={Propertiesunitscampaigns}
                            placeholder="Search"
                          />
                        </Form.Item>
                      </Col>
                    ) : (
                      <Col span={18} style={{ marginTop: "4px", fontSize: 13 }}>
                        {emailList}
                      </Col>
                    )}
                  </Col>
                  <Col style={{ display: "flex", margin: "10px" }}>
                    <Col
                      span={6}
                      className="label-style"
                      style={{ display: "flex", justifyContent: "end" }}
                    >
                      Bcc
                    </Col>

                    {isEditing ? (
                      <Col span={16}>
                        <Form.Item name="Bcc">
                          {/* <Input defaultValue="--" suffix={<CaretDownOutlined />} /> */}

                          <MultiSelect
                            defaultValue="Receipts"
                            width="100%"
                            suffix={<CaretDownOutlined />}
                            options={Propertiesunitscampaigns}
                            placeholder="Search"
                          />
                        </Form.Item>
                      </Col>
                    ) : (
                      <Col style={{ marginTop: "4px", fontSize: 13 }} span={16}>
                        --
                      </Col>
                    )}
                  </Col>

                  <Col style={{ display: "flex", margin: "10px" }}>
                    <Col
                      span={6}
                      className="label-style"
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      {isEditing && (
                        <span style={{ color: "red", marginRight: "3px" }}>
                          *
                        </span>
                      )}
                      Subject
                    </Col>

                    {isEditing ? (
                      <Col span={16}>
                        <Form.Item name="ReportName">
                          <Input defaultValue={scheduleReports.name} />
                        </Form.Item>
                      </Col>
                    ) : (
                      <Col span={16} style={{ marginTop: "4px", fontSize: 13 }}>
                        {scheduleReports.name}
                      </Col>
                    )}
                  </Col>

                  <Col style={{ display: "flex", margin: "10px" }}>
                    <Col
                      span={6}
                      className="label-style"
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      {isEditing && (
                        <span style={{ color: "red", marginRight: "3px" }}>
                          *
                        </span>
                      )}
                      Message
                    </Col>

                    {isEditing ? (
                      <Col span={16}>
                        <Form.Item name="dummt">
                          <TextArea rows={4} defaultValue="dummt" />
                        </Form.Item>
                        <a href="#">Customize My Signature</a>
                      </Col>
                    ) : (
                      <Col style={{ marginTop: "4px", fontSize: 13 }} span={16}>
                        dummt
                      </Col>
                    )}
                  </Col>
                </Col>

                <h1 className="title-style">Schedule</h1>

                <Col
                  span={24}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Col style={{ display: "flex", margin: "10px" }}>
                    <Col
                      className="label-style"
                      span={6}
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      {isEditing && (
                        <span style={{ color: "red", marginRight: "3px" }}>
                          *
                        </span>
                      )}
                      Start Date
                    </Col>

                    {isEditing ? (
                      <Col span={8}>
                        <Form.Item name="date">
                          <Input type="date" />
                        </Form.Item>
                      </Col>
                    ) : (
                      <Col style={{ marginTop: "4px", fontSize: 13 }} span={16}>
                        02/05/2023
                      </Col>
                    )}
                  </Col>
                  <Col style={{ display: "flex", margin: "10px" }}>
                    <Col
                      className="label-style"
                      span={6}
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      {isEditing && (
                        <span style={{ color: "red", marginRight: "3px" }}>
                          *
                        </span>
                      )}
                      Frequency
                    </Col>

                    {isEditing ? (
                      <Col span={12}>
                        <Form.Item name="frequency">
                          <Select
                            defaultValue={scheduleReports.frequency}
                            width="100%"
                            suffix={<DownOutlined />}
                            options={frequencyOptions}
                          />
                        </Form.Item>
                      </Col>
                    ) : (
                      <Col style={{ marginTop: "4px", fontSize: 13 }} span={16}>
                        {scheduleReports.frequency}
                      </Col>
                    )}
                  </Col>

                  <Col style={{ display: "flex", margin: "10px" }}>
                    <Col span={6}></Col>
                    <Col span={18} style={{ fontSize: 13 }}>
                      This report will be emailed every Sunday in the morning.
                      The next email will be sent on 03/12/2023.
                    </Col>
                  </Col>

                  <Col style={{ display: "flex", margin: "10px" }}>
                    <Col span={6}></Col>
                    <Col span={18} style={{ fontSize: 13 }}>
                      Please note: a scheduled report over 20 MB will be emailed
                      with a download link that will only be valid for 7 days.
                    </Col>
                  </Col>
                </Col>
              </Row>
            </Form>
          </Card>
        </Row>

        {isEditing && (
          <Row>
            <div
              style={{ margin: "15px 0px 0px 0px" }}
              className="form-action page-actions-container"
            >
              <Button
                type="primary"
                htmlType="submit"
                onClick={handleSaveClick}
              >
                Save
              </Button>
              <Button onClick={cancelReport}>Cancel</Button>
            </div>
          </Row>
        )}
        <br />
      </div>

      <div className="RightSidebar">
        <RightBar RightBarData={ScheduledReportsRightBar} />
      </div>
    </>
  );
};

export default ScheduledReportsDetails;
